export default __webpack_public_path__ + "static/media/rt-tony-logo-slowdown.93073edd.png";